<template>
  <div class="addon-single">
    <h3 class="title">{{ $props.addonName }}</h3>
    <div v-for="feature in filteredFeatures"
         :key="feature.id"
         class="addon-row">
      <img :src="getAddonImage(feature)" alt="">
      <p class="description">{{ feature.description }}</p>
    </div>
    <div class="addon-actions-row">
      <div class="addon-price">
        {{ $props.addonPrice.formattedValue }} <span class="currency">{{ $t('common.currency') }}</span>
      </div>
      <base-button size="small"
                   class="addon-button" @click="$emit('select-addon')">{{ $t('common.addToCart') }}</base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/base-button'

export default {
  name: 'addon-single',
  components: { BaseButton },
  props: {
    addonName: String,
    addonDescription: String,
    addonFeatures: {
      type: Array,
      default: () => []
    },
    addonPrice: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    filteredFeatures () {
      return this.$props.addonFeatures.filter(feature => {
        return feature.characteristicGroupCommerceType !== 'ADDON_ACTIVATION'
      })
    }
  },
  methods: {
    getAddonImage (feature) {
      return feature?.icon?.url
    }
  }
}
</script>

<style scoped lang="scss">
@mixin flexCenter {
  display: flex;
  align-items: center;
}

.addon-single {
  width: 100%;
  background-color: $white;
  border-radius: 0.5rem;
  padding: 2.4rem;
  color: $text;
  display: flex;
  flex-direction: column;

  .title {
    font-size: 2.4rem;
    margin-bottom: 1.6rem;
  }

  .addon-row {
    @include flexCenter;
    margin-bottom: 2.4rem;

    img {
      width: 3rem;
      height: auto;
      margin-right: 1.6rem;
    }

    .description {
      font-size: 1.5rem;
      margin: 0
    }
  }

  .addon-actions-row {
    @include flexCenter;
    justify-content: space-between;
    margin-top: auto;

    .addon-price {
      font-size: 2.4rem;
      color: $primary;
      font-weight: 600;
      white-space: nowrap;

      .currency {
        font-size: 1.3rem;
        color: $text;
      }
    }

    .addon-button {
      margin-left: auto;
      font-size: 1.2rem;
      padding: 0.7rem 3rem !important;
      min-width: auto;
    }
  }
}
</style>
